import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Modal from 'react-modal';

// import components:
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

// import views:
import Attachments from '../../views/Attachments/Attachments';
import CreateLogin from '../../views/CreateLogin/CreateLogin';
import Kpis from '../../views/Kpis/Kpis';
import Leads from '../../views/Leads/Leads';
import CreateNewLeadSR from '../../views/Leads/CreateNewLeadSR/CreateNewLeadSR';
import LeadDetails from '../../views/LeadDetails/LeadDetails';
import PasswordRecovery from '../../views/PasswordRecovery/PasswordRecovery';
import PasswordReset from '../../views/PasswordReset/PasswordReset';
import Repstats from '../../views/Repstats/Repstats';
import Scheduled from '../../views/Scheduled/Scheduled';
import WorkOrders from '../../views/WorkOrders/WorkOrders';
import SafetyAudit from '../../views/WorkOrder/SafetyAudit';
import WorkOrder from '../../views/WorkOrder/WorkOrder';
import WorkOrderForm from '../../views/WorkOrderForm/WorkOrderForm';
import ScheduledJobDetails from "../../views/ScheduledJobDetails/ScheduledJobDetails";
import Scoreboard from '../../views/Scoreboard/Scoreboard';
import Settings from '../../views/Settings/Settings';
import Training from '../../views/Training/Training';
import Customers from '../../views/Customers/Customers';
import CustomerDetails from "../../views/CustomerDetails/CustomerDetails";
import FieldCustomers from '../../views/FieldCustomers/FieldCustomers';
import FieldCustomerDetails from '../../views/FieldCustomerDetails/FieldCustomerDetails';
import Logout from "../../views/Logout/Logout";
import FieldJob from "../../views/FieldJob/FieldJob";
import FieldJob2 from "../../views/FieldJob2/FieldJob2";
import Blog from "../../views/Blog/Blog";
import PhotoPack from "../../views/PhotoPack/PhotoPack";
import FieldScoreboard from '../../views/FieldScoreboard/FieldScoreboard';
import FieldKpis from '../../views/FieldKpis/FieldKpis';
import ExistingPhotos from '../../views/ExistingPhotos/ExistingPhotos';


// binds 'react-modal' to root element <https://github.com/reactjs/react-modal#api-documentation>:
Modal.setAppElement('#root');


/**
 * @class
 *
 * "Home" includes the site once a user logs in (as opposed to pages that don't require authentication e.g. login, create account, etc.).
 *
 * `Home.js` includes the second tier of client-side routing: route changes directs users to different views/pages. It's therefore imperative
 * that whenever a new page is added, a new `<Route>` and path are added to the routing switch. See documentation on React Router <https://reactrouter.com/web/guides/quick-start> for more info.
 */
const Home = () => {
    // Since we're using `<Switch>` tag, we technically don't need the `exact` attribute -- this is just a safety measure.
    // If only using `<Switch>` we would need to be placed in correct order (otherwise it would match '/' route).
    return (
        <div className="App App--Main">
            <Header />
            <main className="container">
                <Switch>
                    <Route path={['/', '/scoreboard']} exact component={Scoreboard} />
                    <Route path='/create_login' exact component={CreateLogin} />
                    <Route path='/customers/:id' exact component={CustomerDetails} />
                    <Route path='/customers' exact component={Customers} />
                    <Route path='/fieldCustomers' exact component={FieldCustomers} />
                    <Route path='/fieldCustomers/:id' exact component={FieldCustomerDetails} /> 
                    <Route path='/kpis' exact component={Kpis} />
                    <Route path='/leads/:id' exact component={LeadDetails} />
                    <Route path='/leads' exact component={Leads} />
                    <Route path= '/salesRabbit' exact component={CreateNewLeadSR} />
                    <Route path='/password_recovery' exact component={PasswordRecovery} />
                    <Route path='/repStats/:id' exact component={Repstats} />
                    <Route path='/attachment/:id/:name' component={Attachments} />
                    <Route path='/scheduled_jobs' exact component={Scheduled} />
                    <Route path='/workOrders' exact component={WorkOrders} />
                    <Route path='/workOrders/:id' exact component={WorkOrder} />
                    <Route path='/safetyAudit/:id' exact component={SafetyAudit} />
                    <Route path='/workOrderForm/:id' exact component={WorkOrderForm} />
                    <Route path='/scheduled/:job_id' exact component={ScheduledJobDetails} />
                    <Route path='/fieldList/:field_job_id' exact component={FieldJob} />
                    <Route path='/fieldJob/:field_job_id' exact component={FieldJob2} />
                    <Route path='/settings' exact component={Settings} />
                    <Route path='/training' exact component={Training} />
                    <Route path='/blog' exact component={Blog} />
                    <Route path='/hmodScoreboard' exact component={FieldScoreboard} />
                    <Route path='/fieldKpis' exact component={FieldKpis} />
                    <Route path='/photoPack/:type/:sessId/:id' exact component={PhotoPack} />
                    <Route path='/existingPhotos/:id' exact component={ExistingPhotos} />
                    <Route path='/logout' exact component={Logout} />
                </Switch>
            </main>
            <Footer />
        </div>
    );
};

export default Home;
